<template>
  <header>
  <nav>
    <!-- <nav class="flex items-center bg-gray-100 p-6"> -->
    <div class="w-full flex-grow sm:flex sm:items-center sm:w-auto">
    <!-- <div class=" bg-gray-100 flex items-center flex-no-shrink sm:flex sm:items-center sm:w-auto"> -->
      <!-- <div class="container">
      <div class="w-full p-2">
        <md-avatar class="md-large">
          <img src="../assets/images/avatar.png" alt="Avatar">
        </md-avatar>
      </div>
      </div> -->

      <div class="w-full inline-flex items-center">
      
        <div class="w-1/3 p-3">
          <router-link
            :to="{ name: 'login' }"
            class="font-semibold text-xl tracking-tight">
            <button class="bg-blue-800 hover:bg-blue-900 text-white text-xs lg:text-base font-bold py-2 px-3 rounded" style="float:left;">
              Administración
            </button>
          </router-link>   


        </div>

      <div class="w-1/3 p-2">
        <router-link
            :to="{ name: 'home' }"
            class="font-semibold text-xl tracking-tight">
          <img src="../assets/images/logo-horizontal.png" alt="Logo" style="display:block; margin:auto;">
          </router-link>        
      </div>

      <div class="w-1/3 p-3">
        <router-link
          :to="{ name: 'ask-for-help' }"
          class="font-semibold text-xl tracking-tight">
          <button class="bg-blue-800 hover:bg-blue-900 text-white text-xs lg:text-base font-bold py-2 px-3 rounded" style="float: right;">
            Asistencia
          </button>
        </router-link>   


      </div>
      </div>


    </div>

  </nav>
  </header>
</template>

<script>

export default {
  name: "Header",
};
</script>
